module.exports = __webpack_public_path__ + "img/1504207201.d158519f.jpg";